import client from 'client';
import { useQuery } from 'react-query';
import { AppExtensionsResponse } from 'extensions/types/appExtension';

export async function fetchAppExtensions<AppExtensionsResponse>(
    eventId: number,
    integrationPoint: string
) {
    return (
        await client().get<AppExtensionsResponse>(
            `/api/v2/developer/events/${eventId}/extensions?integrationPoint=${integrationPoint}`
        )
    ).data;
}

const useAppExtensions = (eventId?: number, integrationPoint?: string) => {
    return useQuery<AppExtensionsResponse, Error>(
        ['appExtensions', eventId, integrationPoint],
        () => fetchAppExtensions(eventId, integrationPoint),
        {
            staleTime: Infinity,
            retry: 3,
            enabled: !!eventId && !!integrationPoint,
        }
    );
};

export default useAppExtensions;
